import React, { useCallback } from 'react';
import { batch, useDispatch } from 'react-redux';
import { Icon, Tappable } from '@vectord/components';

import {
  MENTEE_MODULE_STATUSES,
  setDeleteSuperBatchModuleModalState,
  setSelectedSuperBatchModule,
} from 'features/moduleManagement';

function DeleteSuperBatchModuleButton({ superBatchModule }) {
  const dispatch = useDispatch();

  const handleOnDelete = useCallback(() => {
    batch(() => {
      dispatch(setDeleteSuperBatchModuleModalState(true));
      dispatch(
        setSelectedSuperBatchModule({
          ...superBatchModule,
          updatedStatus: MENTEE_MODULE_STATUSES.deprecated,
        })
      );
    });
  }, [dispatch, superBatchModule]);

  return (
    <Tappable
      className="danger"
      onClick={handleOnDelete}
    >
      <Icon name="trash" />
    </Tappable>
  );
}

export default DeleteSuperBatchModuleButton;
